import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/WhatsApp_logo.png'
import _imports_1 from '@/assets/pitchyou_logo.png'


const _hoisted_1 = { class: "container-desktop" }
const _hoisted_2 = {
  key: 0,
  alt: "WhatsApp logo",
  src: _imports_0,
  class: "logo-desktop"
}
const _hoisted_3 = { class: "tenantLogoContainer" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "qr-code-container" }
const _hoisted_6 = {
  key: 0,
  class: "qr-code-wrapper"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "scan-text" }, "scan to start", -1)
const _hoisted_9 = {
  key: 0,
  class: "powered-by-text"
}
const _hoisted_10 = {
  key: 1,
  alt: "Powered by PitchYou",
  src: _imports_1,
  class: "footer-logo-desktop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoadingDone)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.logoGuid)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.logoPath + _ctx.logoGuid,
            class: "tenantLogo",
            alt: "Logo"
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isLoadingDone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: _ctx.qrCodeUrl,
                alt: "QR Code",
                class: "qr-code-image"
              }, null, 8, _hoisted_7)
            ]),
            _hoisted_8,
            (_ctx.isLoadingDone)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button-desktop",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openUrl && _ctx.openUrl(...args)))
                }, " or use WhatsApp Desktop client "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "container-footer-desktop",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPitchYouTab && _ctx.openPitchYouTab(...args)))
    }, [
      (_ctx.isLoadingDone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "powered by"))
        : _createCommentVNode("", true),
      (_ctx.isLoadingDone)
        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
        : _createCommentVNode("", true)
    ])
  ], 64))
}